import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static {
}
$ const {
  class: inputClass,
  type,
  number,
  ...htmlInput
} = input;
$ const roundedNumber = Math.round(+(number === undefined ? NaN : number));
<if(roundedNumber > 0)>
  <span ...processHtmlAttributes(htmlInput) role=(type !== "menu" && type !== "icon" && "img") class=["badge", inputClass]>
    ${roundedNumber > 99 ? "99+" : roundedNumber}
  </span>
</if>